import http_multipart from "@/http-multipart";
import httpCommon from "@/http-common";

class TextEditorService {
    addImageInPost(formData) {
        return http_multipart.post("/notify-school/add_image", formData);
    }

    removeImagePost(id) {
        return httpCommon.delete("/notify-school/remove_image", {
            params: {
                id: id
            }
        });
    }

    removeMultiImagePost(ids) {
        return httpCommon.delete("/notify-school/remove_multi_image", {
            data: ids
        });
    }

    setDelActiveImage(imageDelete, imageAdd) {
        return httpCommon.put("/notify-school/active", {
            imageAdd: imageAdd,
            imageDelete: imageDelete
        })
    }
}

export default new TextEditorService();